export default __webpack_public_path__ + "static/media/5.b9657d22.png";